import { isV6EthersProvider } from '../utils/ethers';
import { SUPPORTED_CHAINS } from '../utils';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const getTxOptions = /* @__PURE__ */ __name(async (signer, chainId, maxFeePerGas, maxPriorityFeePerGas) => {
  if (!maxFeePerGas || !maxPriorityFeePerGas) {
    chainId = chainId ?? await getChainIdSafe(signer);
    const gasStation = SUPPORTED_CHAINS[chainId]?.gasStation;
    if (gasStation) {
      const gasFees = await gasStation();
      maxFeePerGas = gasFees?.maxFeePerGas ?? 0;
      maxPriorityFeePerGas = gasFees?.maxPriorityFeePerGas ?? 0;
    }
  }
  return maxFeePerGas && maxPriorityFeePerGas ? { maxFeePerGas, maxPriorityFeePerGas } : {};
}, "getTxOptions");
const getChainIdSafe = /* @__PURE__ */ __name(async (signer) => {
  if (isV6EthersProvider(signer.provider)) {
    const network = await signer.provider?.getNetwork();
    if (!network?.chainId) throw new Error("Cannot determine chainId: provider is missing");
    return network.chainId;
  }
  return await signer.getChainId();
}, "getChainIdSafe");
const getSignerAddressSafe = /* @__PURE__ */ __name(async (signer) => {
  if (isV6EthersProvider(signer.provider)) {
    return await signer.getAddress();
  }
  return await signer.getAddress();
}, "getSignerAddressSafe");

export { getChainIdSafe, getSignerAddressSafe, getTxOptions };
